module.exports = "/assets/images/nervous.png";